import { useRef, useEffect } from 'react';
import deepEqual from 'react-fast-compare';

function useDeepEffect(effect, deps) {
  const prevDepsRef = useRef(undefined);
  const depsChanged = !prevDepsRef.current || !deepEqual(prevDepsRef.current, deps);
  if (depsChanged) {
    prevDepsRef.current = deps;
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, [depsChanged]);
}

export { useDeepEffect as default };
